import MUIIconButton from "@mui/material/IconButton";

const IconButton = MUIIconButton;

export default IconButton;
